HTMLElement.prototype.getAllElementsByText = function (text: string, searchType: SearchType = 'includes'): HTMLElement[] {
	const elements: HTMLElement[] = Array.from(this.querySelectorAll('*'));
	return elements.filter(el => {
		if (!el.firstChild) return false;
		let textContentNode = el.firstChild as ChildNode;
		if (textContentNode.nodeType == Node.TEXT_NODE) {
			textContentNode = textContentNode as Text;
			switch (searchType) {
				case 'includes':
					return textContentNode.textContent.includes(text);
				case 'startsWith':
					return textContentNode.textContent.startsWith(text);
				case 'endsWith':
					return textContentNode.textContent.endsWith(text);
				case 'exact':
					return textContentNode.textContent == text;
				default:
					return textContentNode.textContent.includes(text);
			}
		}
		return false;
	});
};

export {};
